const KILO_ROUNDING_LIMIT = 999_950;

function dropTrailingZero(fixed: string): string {
  return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
}

export function formatCount(count: number): string {
  if (count < 1_000) {
    return String(count);
  }
  if (count < KILO_ROUNDING_LIMIT) {
    return `${dropTrailingZero((count / 1_000).toFixed(1))}k`;
  }
  return `${dropTrailingZero((count / 1_000_000).toFixed(1))}m`;
}
